import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CareerComponent from "../components/career_component";
import * as UserActions from "../actions";

const mapStateToProps = state => (state.user);

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(UserActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CareerComponent);
